import { getRouteApi } from '@tanstack/react-router';

import { GymDetailScreen } from './GymDetailScreen';

const route = getRouteApi('/gyms/$gymId');

export function GymDetailRoute() {
  const { gymId } = route.useParams();
  return <GymDetailScreen gymId={gymId} />;
}
